var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseHeader',{attrs:{"title":_vm.title,"actions":_vm.actions,"glass":_vm.glass,"flat":!_vm.glass,"large":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }